(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/@react-spring/parallax/dist/react-spring-parallax.esm.js + 5 modules
var react_spring_parallax_esm = __webpack_require__(55504);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FirstShot/First.tsx



const FirstLandingPage = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-[70%] flex flex-row items-center mt-[8%] ".concat(props.ready < 2 && "hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min relative flex flex-row justify-center pr-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-min h-min relative flex flex-col gap-6 items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "".concat(props.ready < 3 ? "scale-0" : "scale-100", " transition-all duration-700"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-9xl xl:text-7xl font-extrabold dark:text-white font-montserrat bg-gradient-to-br from-emerald-400/80 to-cyan-500/80 text-transparent bg-clip-text transition-all",
                                style: {},
                                children: "Disadus"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "dark:text-gray-100/70 xl:text-sm text-2xl flex flex-row items-center gap-1.5 ".concat(props.ready < 3 && "-translate-y-full opacity-0", " transition-all delay-500 duration-700 font-wsans"),
                            children: [
                                "The modern tool students",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold dark:text-white bg-gradient-to-br from-emerald-400 to-cyan-400 text-transparent bg-clip-text ".concat(props.ready < 3 && "-translate-y-full opacity-0", " transition-all delay-[900ms] duration-700"),
                                    children: "deserve"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row gap-4 w-full items-center justify-start xl:text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/signup/pre",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: " bg-gradient-to-br from-emerald-400 to-cyan-500 dark:from-emerald-600 dark:to-cyan-700 dark:text-gray-50/80 dark:hover:from-emerald-700 dark:hover:to-cyan-800 transition-all text-white font-montserrat font-bold rounded-xl shadow-md hover:shadow-xl shadow-cyan-900/50 hover:shadow-cyan-900/80 py-2 px-4 xl:py-2 xl:px-4\n                ".concat(props.ready < 3 && "-translate-y-full opacity-0", " transition-all delay-[1200ms] duration-500\n                "),
                                        children: "Get Started"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cursor-pointer dark:text-gray-50/40 text-gray-700/40 hover:underline underline-offset-2 dark:hover:text-gray-50\n                ".concat(props.ready < 3 && "-translate-x-full opacity-0", " transition-all delay-[1700ms] duration-500\n                "),
                                        children: "Login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FirstShot/FirstBackground.tsx


const FirstLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-cyan-50 dark:bg-black"
            })
        })
    });

// EXTERNAL MODULE: ./utils/hooks/self/useSelfInfo.ts
var useSelfInfo = __webpack_require__(76188);
;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FirstShot/FirstContentScreenshot.tsx





const FirstLandingPageContentPreview = (props)=>{
    const { ready , setReady  } = props;
    const videoRef = (0,react.useRef)(null);
    const user = (0,useSelfInfo/* useCurrentUser */.x)();
    const [theme, setTheme] = (0,react.useState)(user === null || user === void 0 ? void 0 : user.theme);
    (0,react.useEffect)(()=>{
        setTheme((theme)=>user && typeof user.theme !== "undefined" ? user.theme : theme);
    }, [
        user
    ]);
    (0,react.useLayoutEffect)(()=>{
        setTheme((theme)=>typeof theme !== "undefined" ? theme : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? 1 : 0);
    }, []);
    const vidlink = lib/* isMacOs */.Q5 ? theme ? "/landing/darkLandingFirstVid4kMac.mp4" : "/landing/landingFirstVid4kMac.mp4" : theme ? "/landing/darkLandingFirstVid4kWin.mp4" : "/landing/landingFirstVid4kMac.mp4";
    (0,react.useLayoutEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.currentTime = videoRef.current.duration || 0;
        }
        if (videoRef.current && ready == 2) {
        // videoRef.current.play()
        }
        if (videoRef.current && ready >= 4) {
            // videoRef.current.pause()
            videoRef.current.currentTime = videoRef.current.duration;
        }
    }, [
        ready
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: -2,
        offset: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-end justify-end relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: vidlink,
                muted: true,
                loop: false,
                controls: false,
                className: "h-full ".concat(ready >= 4 && "animate-bounce-mini"),
                onLoadedData: (e)=>{
                    // alert('loaded')
                    setReady(1);
                },
                playsInline: true,
                ref: videoRef,
                id: "landingFirstVid"
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(61782);
;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FirstShot/ScrollArrow.tsx



const ScrollDownArrow = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 15,
        factor: 0.1,
        offset: 0.9,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row justify-center items-end pb-8 ".concat(props.ready < 3 && "opacity-0", " transition-all duration-500 delay-[2000ms]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                className: "w-4 h-4 dark:text-white text-gray-800/40 animate-bounce"
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SecondShot/Second.tsx


const SecondLandingPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 2,
        offset: 0.867,
        factor: 2.2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-start items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start ml-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-extrabold font-montserrat text-5xl",
                            children: "All Your Learning in One Place"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-wsans text-2xl",
                            children: "Disadus integrates with Schoology, to ensure everything is synced and easily accessible. Access your courses, assignments, and more on Disadus!"
                        })
                    ]
                })
            })
        })
    });

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SecondShot/SecondImageScreenshot.tsx



const SecondLandingPageImagePreview = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1.4,
        offset: 0.9,
        factor: 1.55,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start relative mr-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] dark:opacity-30 opacity-70 z-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/landing/shot1bg.png",
                                    className: "dark:contrast-125 dark:brightness-50 hue-rotate-[20deg] w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:block hidden z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot2.png",
                                    width: "1920",
                                    height: "1080",
                                    className: "rounded-xl z-20",
                                    alt: "Screenshot of Disadus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:hidden block z-10 drop-shadow-md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot2light.png",
                                    width: "2560",
                                    height: "1600",
                                    className: "rounded-xl z-30",
                                    // priority
                                    alt: "Screenshot of Disadus"
                                })
                            })
                        ]
                    })
                })
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SecondShot/SecondBackground.tsx


const SecondLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 0.99999,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-blue-50 dark:bg-[rgb(15,15,17)]"
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/ThirdShot/Third.tsx


const ThirdLangingPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 2,
        offset: 1,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start mr-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-extrabold font-montserrat text-5xl xl:text-3xl",
                            children: "Designed for the 21st-Century Student"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-wsans text-2xl xl:text-lg",
                            children: "Many other Learning Management Systems on the market leave students with a barely functioning app. Disadus is designed with students in mind, easy to use, and intuitive alternative to other LMS systems."
                        })
                    ]
                })
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FourthShot/Fourth.tsx


const FourthLandingPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 2.08,
        offset: 1.9,
        factor: 2.2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-start items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start ml-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "font-extrabold font-montserrat text-4xl flex flex-row items-center gap-3",
                            children: [
                                "Personalized for ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "bg-gradient-to-r from-blue-400 to-emerald-400 text-transparent bg-clip-text font-wsans text-6xl",
                                    children: "YOU"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-wsans text-2xl",
                            children: "Disadus is designed for customizability. We've made it easy to customize your account to fit your needs from changing how your courses look to how you organize your assignments."
                        })
                    ]
                })
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FourthShot/FourthImageScreenshot.tsx



const FourthLandingPageImagePreview = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 0.5,
        offset: 1.7,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start relative mr-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:block hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot2.png",
                                    width: "1920",
                                    height: "1080",
                                    className: "rounded-xl z-20",
                                    priority: true,
                                    alt: "Screenshot of Disadus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:hidden block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot2light.png",
                                    width: "1920",
                                    height: "1080",
                                    className: "rounded-xl z-20",
                                    priority: true,
                                    alt: "Screenshot of Disadus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] dark:opacity-30 opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/landing/shot1bg.png",
                                    className: "dark:contrast-125 dark:brightness-50 hue-rotate-[20deg] w-full h-full"
                                })
                            })
                        ]
                    })
                })
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FourthShot/FourthBackground.tsx


const FourthLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 1.9999,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-blue-50 dark:bg-[rgb(15,15,17)]"
            })
        })
    });

// EXTERNAL MODULE: ./utils/hooks/community/useCommunitySearch.ts
var useCommunitySearch = __webpack_require__(40333);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/UserGroupIcon.js
var UserGroupIcon = __webpack_require__(63233);
;// CONCATENATED MODULE: ./components/Landing/CommunitySearchResult.tsx



const CommunitySearchResult = (props)=>{
    const { community  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/signup/?community=".concat(community.id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-3 w-full flex flex-row gap-4 first:border-none border-t dark:border-gray-700  transition-all cursor-pointer group relative overflow-hidden flex-shrink-0 items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-12 h-12 z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: community.image,
                        alt: "",
                        className: "w-12 h-12 rounded-xl shadow-md"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2 justify-center z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-semibold",
                            children: community.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm font-medium flex flex-row gap-1 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserGroupIcon/* default */.Z, {
                                    className: "w-4 h-4"
                                }),
                                " ",
                                community.members.length
                            ]
                        })
                    ]
                }),
                (community === null || community === void 0 ? void 0 : community.vanitybg) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full h-full absolute top-0 left-0 z-0 opacity-50 -translate-x-full group-hover:translate-x-0 transition-all duration-300",
                    style: {
                        WebkitMaskImage: "linear-gradient(to right, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 10%, rgba(0,0,0,0.5) 20%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0) 90%)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: community.vanitybg,
                        className: "w-full h-full object-cover object-center"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Landing/CommunitySearchResults.tsx




const CommunitySearchResults = ()=>{
    const [query, setQuery] = (0,react.useState)("");
    const results = (0,useCommunitySearch/* useCommunitySearch */.T)(query);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: (e)=>e.preventDefault(),
        className: "flex flex-col w-full h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row gap-4 items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full h-20 flex flex-row items-center flex-shrink-0 z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "w-full h-full text-lg px-8 dark:bg-gray-750 bg-gray-50 hover:bg-white focus:bg-white drop-shadow-sm hover:shadow-lg focus:shadow-lg dark:text-gray-200 transition-all rounded-xl ".concat((results === null || results === void 0 ? void 0 : results.length) && query && "rounded-b-none"),
                        placeholder: "Find your school name here",
                        value: query,
                        onChange: (e)=>setQuery(e.target.value)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative ".concat((results === null || results === void 0 ? void 0 : results.length) && query ? "h-96" : "h-0", " transition-all duration-200 w-full dark:bg-gray-800 rounded-b-xl"),
                children: !!(results === null || results === void 0 ? void 0 : results.length) && !!query && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col overflow-auto absolute w-full h-full scrollbar-none",
                    children: results === null || results === void 0 ? void 0 : results.map((result)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CommunitySearchResult, {
                            community: result
                        }))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FifthShot/Fifth.tsx



const FifthLandingPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 2,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-start",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-min flex flex-col justify-center items-center gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-extrabold font-montserrat text-5xl",
                        children: "Ready?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-wsans text-2xl",
                        children: "Start your journey by looking for your school!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full max-w-prose",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunitySearchResults, {})
                    })
                ]
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/FifthShot/FifthBackground.tsx


const FifthLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 2,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-cyan-50 dark:bg-gray-900"
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/ThirdShot/ThirdContentScreenshot.tsx



const ThirdLandingPageContentPreview = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 4,
        offset: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-start items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:block hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot1.png",
                                    width: "1920",
                                    height: "1080",
                                    className: "rounded-xl z-20",
                                    priority: true,
                                    alt: "Screenshot of Disadus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full dark:hidden block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/landing/shot1light.png",
                                    width: "1920",
                                    height: "1080",
                                    className: "rounded-xl z-20",
                                    alt: "Screenshot of Disadus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] dark:opacity-30 opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/landing/shot1bg.png",
                                    className: "dark:contrast-125 dark:brightness-50 hue-rotate-[20deg] w-full h-full"
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/ThirdShot/ThirdBackground.tsx


const ThirdLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 1,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-cyan-50 dark:bg-gray-900"
            })
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/Navbar.tsx


const NavbarLayer = ()=>// <ParallaxLayer speed={-1} offset={0} factor={1} className={`pointer-events-none`}>
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full flex flex-row items-start justify-start fixed pointer-events-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row gap-4 w-full h-20 p-4 dark:bg-black/30 pointer-events-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/hopperAppIcon.png",
                        className: "w-12 h-12 rounded-xl shadow-lg shadow-cyan-900/70 cursor-pointer hover:shadow-xl hover:shadow-cyan-900/80 transition-all duration-500"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-16 flex-grow h-full items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "?sec=top",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-extrabold font-wsans text-2xl text-gray-900/20 dark:text-gray-100/25 uppercase hover:bg-gradient-to-br from-emerald-400 to-cyan-500 before:hover:text-transparent bg-clip-text cursor-pointer",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "?sec=faq",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-extrabold font-wsans text-2xl text-gray-900/20 dark:text-gray-100/25 uppercase hover:bg-gradient-to-br from-emerald-400 to-cyan-500 hover:text-transparent bg-clip-text cursor-pointer",
                                children: "FAQ"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://discord.gg/X6uJzWFx9k",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-extrabold font-wsans text-2xl text-gray-900/20 dark:text-gray-100/25 uppercase hover:bg-gradient-to-br from-emerald-400 to-cyan-500 dark:from-emerald-600 dark:to-cyan-700 hover:text-transparent bg-clip-text cursor-pointer",
                                children: "Discord"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/app",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: " bg-gradient-to-br from-emerald-400 to-cyan-500 dark:from-emerald-600 dark:to-cyan-700 dark:text-gray-50/80 dark:hover:from-emerald-700 dark:hover:to-cyan-800 transition-all  text-white font-wsans font-bold rounded-xl shadow-lg hover:shadow-xl shadow-cyan-900/50 hover:shadow-cyan-900/70 py-3 px-6 xl:py-2 xl:px-4 w-max h-min",
                        children: "Launch App"
                    })
                })
            ]
        })
    });

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SixthShot/Sixth.tsx


const SixthLandingPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 2.99999,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-start",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-8 w-2/3 h-min items-start justify-start ml-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-extrabold font-montserrat text-5xl flex flex-row items-center gap-3",
                        children: "Frequently Asked Questions"
                    })
                })
            })
        })
    });

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/PlusIcon.js
var PlusIcon = __webpack_require__(76763);
;// CONCATENATED MODULE: ./components/Landing/FAQs/FAQEntry.tsx



const FAQEntry = (props)=>{
    const { question , answer  } = props;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-min flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-4 items-center group cursor-pointer",
                        onClick: ()=>setOpen(!open),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-extrabold font-montserrat text-3xl flex flex-row items-center gap-3 flex-grow",
                                children: question
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* default */.Z, {
                                className: "w-6 h-6 cursor-pointer ".concat(open && "rotate-45", " transition-all flex-shrink-0")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-wsans text-2xl break-words ".concat(!open ? "hidden" : "block", " h-max overflow-hidden"),
                        children: answer
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-0.5 bg-gray-900/60 last:hidden"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SixthShot/SixthFAQ.tsx



const SixthLandingPageFAQ = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 2.99999,
        factor: 1,
        id: "faq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex flex-row items-center justify-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 h-min flex flex-row justify-start items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-2/3 h-min items-start justify-start gap-3 ml-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQEntry, {
                            question: "How much does it cost?",
                            answer: "Zero. We don't think students should be required to fork up money to use Disadus. However, there may be an optional membership program in the future!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQEntry, {
                            question: "Why can't I find my school?",
                            answer: "Most school communities are set up by a student at that specific school. If there isn't a community for your school, you could create your own or ask us to create one for you!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQEntry, {
                            question: "When will you support PowerSchool/Canvas/Other Learning Service?",
                            answer: "We have plans to support other learning services in the future, however, we are currently only supporting Schoology. You can get notified when we support other learning services by joining our Discord server."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQEntry, {
                            question: "How do you make money?",
                            answer: "At the moment, we don't make money. We don't prioritize profit at the moment. However, we may explore some non-intrusive methods in the future."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQEntry, {
                            question: "How do I propose a suggestion?",
                            answer: "You can propose a suggestion by shooting us a message on Discord in the #faq channel."
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Landing/ParallaxLayers/SixthShot/SixthBackground.tsx


const SixthLandingPageBackground = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_parallax_esm/* ParallaxLayer */._, {
        speed: 1,
        offset: 2.99999,
        factor: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[100%] relative dark:opacity-100 opacity-100 bg-blue-50 dark:bg-[rgb(15,15,17)]"
            })
        })
    });

;// CONCATENATED MODULE: ./pages/index.tsx




// import { LandingScroll1 } from '../components/LandingPageComponents/LandingScroll/Scroll1'
// import LandingScroll2 from '../components/LandingPageComponents/LandingScroll/Scroll2'
// import LandingScroll3 from '../components/LandingPageComponents/LandingScroll/Scroll3'
// import LandingScroll4 from '../components/LandingPageComponents/LandingScroll/Scroll4'
// import LandingScroll5 from '../components/LandingPageComponents/LandingScroll/Scroll5'
// import LandingScroll8 from '../components/LandingPageComponents/LandingScroll/Scroll8'
// import { LandingCanvasScrollRenderer } from '../components/LandingPageComponents/LandingScroll/LandingCanvasScrollRenderer'





















const Description = "Disadus is a tool that helps students increase their productivity and form school communities with their peers to achieve academic success!";
const renderVideo = ()=>{
    if (isSafari || isMobileSafari) return true;
    return false;
};
// import KUTE from "kute.js"
const Home = ()=>{
    const router = (0,next_router.useRouter)();
    // const scrollable1 = useRef<HTMLDivElement>(null)
    // const video = useRef<HTMLVideoElement>(null)
    const [videoReady, setvideoReady] = (0,react.useState)(0);
    const paraRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (videoReady === 1) {
            setTimeout(()=>{
                setvideoReady(2);
            }, 500);
        }
        if (videoReady === 2) {
            setTimeout(()=>{
                setvideoReady(3);
            }, 300);
        }
        if (videoReady === 3) {
            setTimeout(()=>{
                setvideoReady(4);
            }, 1000);
        }
    }, [
        videoReady
    ]);
    (0,react.useEffect)(()=>{
        if (paraRef.current) {
            switch(router.query.sec){
                case "faq":
                    paraRef.current.scrollTo(3.5);
                    break;
                case "top":
                    paraRef.current.scrollTo(0);
                    break;
                default:
                    break;
            }
        }
    }, [
        router
    ]);
    (0,react.useLayoutEffect)(()=>{
        localStorage.getItem("token") && router.push("/app");
    }, []);
    // useEffect(() => {
    //   if (video.current && scrollable1.current) {
    //     const sc = scrollable1.current!
    //     const onScroll = () => {
    //       const vid = video.current!
    //       const scrollPercent = (sc.scrollTop / (sc.scrollHeight - sc.clientHeight)) * 100
    //       vid.currentTime = vid.duration * (scrollPercent / 100)
    //     }
    //     sc.addEventListener('scroll', onScroll)
    //     return () => {
    //       sc.removeEventListener('scroll', onScroll)
    //     }
    //   }
    // }, [router])
    return(// <div className={`w-full h-full relative overflow-auto dark:bg-gray-900`}>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Disadus - The helpful tool students deserve"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/logoold.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: Description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#66ffe0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Disadus - The helpful tool students deserve"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: Description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://disadus.app/landing/embed.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://disadus.app"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Disadus"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: "en_US"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-0 ".concat(videoReady && "translate-y-full", " bg-gray-50 dark:bg-gray-900 z-20 duration-500 delay-150 transition-all ").concat(videoReady >= 2 && "hidden")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_spring_parallax_esm/* Parallax */.V, {
                pages: 3.5,
                className: "scrollbar-none bg-cyan-50 dark:bg-gray-900",
                ref: paraRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstLandingPageContentPreview, {
                                ready: videoReady,
                                setReady: setvideoReady
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollDownArrow, {
                                ready: videoReady
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstLandingPage, {
                                ready: videoReady
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondLandingPageImagePreview, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondLandingPage, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdLandingPageContentPreview, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdLangingPage, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthLandingPageImagePreview, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthLandingPage, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FifthLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FifthLandingPage, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SixthLandingPageBackground, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SixthLandingPage, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SixthLandingPageFAQ, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLayer, {})
        ]
    }));
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 40333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useCommunitySearch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _classes_Fetcher__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69705);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86353);



const useCommunitySearch = (query)=>{
    const [results, setResults] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!query) {
            setResults(null);
            return;
        }
        (0,_classes_Fetcher__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .API_DOMAIN */ .hW, "/communities/search/").concat(query)).then((response)=>response.ok && response.json()).then((response)=>response && setResults(response));
    }, [
        query
    ]);
    return results;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,9259,6003,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);